module.exports = __webpack_public_path__ + "media/click.59fc3adb.mp3";